import LocationItem from './LocationItem';

export default LocationItem;
